// extracted by mini-css-extract-plugin
export default {"error":"ErrorFeedback_error__uzpQP","error-icon":"ErrorFeedback_error-icon__Ijneo","error-text":"ErrorFeedback_error-text__cmGQR"};